var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTravail = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 24.5h24.05V.45H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(0 -.95)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B2B2B2",
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M5.186 7.3a2.67 2.67 0 0 0-2.672 2.662v7.92a2.67 2.67 0 0 0 2.672 2.662h13.7a2.659 2.659 0 0 0 2.65-2.662v-7.92a2.66 2.66 0 0 0-2.65-2.661h-13.7zm13.7 13.733h-13.7a3.16 3.16 0 0 1-3.161-3.15v-7.92a3.16 3.16 0 0 1 3.161-3.151h13.7a3.149 3.149 0 0 1 3.139 3.15v7.92a3.148 3.148 0 0 1-3.14 3.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B2B2",
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M7.715 6.812h8.552a2.404 2.404 0 0 0-2.396-2.406h-3.76a2.407 2.407 0 0 0-2.396 2.406zm8.997.489H7.271l-.03-.21a2.917 2.917 0 0 1 .833-2.324c.54-.54 1.281-.85 2.037-.85h3.76a2.893 2.893 0 0 1 2.871 3.174l-.03.21z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B2B2",
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M13.109 13.45h8.707v-.489h-8.707zM2.304 13.45h8.647v-.489H2.303z",
  mask: "url(#b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B2B2B2",
  stroke: "#B2B2B2",
  strokeWidth: 0.5,
  d: "M12.018 11.081a.99.99 0 0 0-.982.996v2.467c0 .55.44.996.982.996a.997.997 0 0 0 .996-.996v-2.467a.997.997 0 0 0-.996-.996m0 4.948a1.48 1.48 0 0 1-1.47-1.485v-2.467c0-.818.66-1.485 1.47-1.485.819 0 1.485.667 1.485 1.485v2.467c0 .819-.666 1.485-1.485 1.485",
  mask: "url(#b)"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTravail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/travail.8164186e1f93e0f6adf760118543468a.svg";